import { NavLink, Outlet, Link } from 'react-router-dom';
import { useEventContext } from '../lib/useEvent';

export function Layout() {
  const { event } = useEventContext();
  const year = new Date().getFullYear();

  return (
    <div className="site">
      <a className="skip-link" href="#main">
        Skip to main content
      </a>

      <header className="site-header">
        <div className="container">
          <Link to="/" className="brand">
            <span className="brand-mark" aria-hidden="true">
              HB
            </span>
            <span>{event?.name ?? 'HB 1500m Swim'}</span>
          </Link>

          <nav className="site-nav" aria-label="Main">
            <NavLink to="/" end>
              Event
            </NavLink>
            <NavLink to="/register">Enter</NavLink>
            <NavLink to="/my-entry">Find my entry</NavLink>
            <NavLink to="/start-lists">Start lists</NavLink>
          </nav>
        </div>
      </header>

      <main className="site-main" id="main">
        <div className="container">
          <Outlet />
        </div>
      </main>

      <footer className="site-footer">
        <div className="container spread">
          <span>
            &copy; {year} {event?.name ?? 'HB 1500m Swim'}
            {event?.contactEmail && (
              <>
                {' '}
                &middot; <a href={`mailto:${event.contactEmail}`}>{event.contactEmail}</a>
              </>
            )}
          </span>
          <Link to="/admin">Organiser sign-in</Link>
        </div>
      </footer>
    </div>
  );
}
